export default {
    api: {
        uri: process.env.VUE_APP_API_URI
    },
    asset: {
        base: process.env.VUE_APP_ASSET_URI
    }
}